/* eslint-disable */

import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import HeaderTable from '../BaseComponent/HeaderTable'
import {Link} from 'react-router-dom'
import {message, Pagination} from 'antd'
import jMoment from 'moment-jalaali'
import moment from 'moment-jalali'
// import {
//   GoogleApiWrapper,
//   InfoWindow,
//   Map,
//   Marker,
//   Polyline,
// } from "google-maps-react";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import $ from 'jquery'
import cookie from 'react-cookies'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import FromToPicker from '../BaseComponent/FromToPicker'
import SearchableCombo from '../BaseComponent/searchableCombo'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import Loader from '../loaders/loader'
import TimeDisplay from '../BaseComponent/timeDisplay'
import {divIcon} from 'leaflet'
import {renderToStaticMarkup} from 'react-dom/server'
import {Map, Marker, TileLayer, Popup, Polyline} from 'react-leaflet'
import {ThemeConsumer} from 'styled-components'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'

class DeliveryPackByLocation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      printInfo: [],
      delivery: [],
      partDelivery: [],
      buttonClicked: false,
      fromDate: '',
      toDate: '',
      grouping: 0,
      Drivers: [],
      driverId: '',
      positions: [],
      showingInfoWindow: false,
      activeMarker: {},
      selectedPlace: {},
      current: 1,
      pageSize: 10,
      timesInterval: [],
      sortData: [
        {
          name: 'ردیف',
          value: 'driverId',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'راننده',
          value: 'driverId',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'شیفت زمانی',
          value: 'driverId',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تاریخ تحویل',
          value: 'deliveryTime',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'تحویل',
          value: 'driverId',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'شناسه فاکتور',
          value: 'invoiceId',
          sorted: false,
          direction: null,
          sortable: false
        },
        // {
        //   name: "شماره فاکتور",
        //   value: "invoiceNum",
        //   sorted: false,
        //   direction: null,
        //   sortable: false,
        // },
        {
          name: 'خریدار',
          value: 'buyerName',
          sorted: false,
          direction: null,
          sortable: false
        },
        // {
        //   name: "تحویل گیرنده",
        //   value: "driverId",
        //   sorted: false,
        //   direction: null,
        //   sortable: false,
        // },
        // {
        //   name: "موبایل",
        //   value: "driverId",
        //   sorted: false,
        //   direction: null,
        //   sortable: false,
        // },
        {
          name: 'آدرس',
          value: 'address',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'وضعیت تحویل',
          value: 'driverId',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'موقعیت',
          value: 'driverId',
          sorted: false,
          direction: null,
          sortable: false
        }
      ],
      sortBy: ''
    }
  }

  getDeliveryByLocation = (
    pageNumber = sessionStorage.getItem('pageNumber'),
    pageSize = sessionStorage.getItem('dropDownVal'),
    params = sessionStorage.getItem('params')
  ) => {
    this.setState({
      loading: true
    })
    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_DELIVERY_LOCATION
        }?export=true&pageNumber=${pageNumber}&pageSize=${pageSize}&${params}`,
        {}
      )
      .then((response) => {
        if (response.data.error === null) {
          $('.showBaseTable,.print').fadeIn()

          var result = response.data.object.result
          var pos = []
          for (let i = 0; i < result.length; i++) {
            let positionObject = {
              lat: result[i].latitude,
              lng: result[i].longitude,
              dispatchDate: result[i].dispatchDate,
              driverName: result[i].driver ? result[i].driver.name : ''
            }
            pos.push(positionObject)
          }
          this.setState({
            delivery: response.data.object.result,
            partDelivery: response.data.object.result.slice(0, 10),
            buttonClicked: true,
            countAll: response.data.object.countAll,
            positions: pos,
            length: response.data.object.result.length,
            loading: false
          })
        } else {
          $('.showBaseTable,.print').fadeOut()
          this.setState({
            loading: false,
            positions: [],
            delivery: []
          })
        }
      })
  }

  //

  getReport = (exportStatus) => {
    this.setState({
      loading: true
    })
    let filter = this.createFilter(exportStatus)

    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_DELIVERY_LOCATION}`, {
        params: filter
      })
      .then((response) => {
        this.setState({
          loading: false
        })
        if (response.data.error === null) {
          $('.showBaseTable,.print').fadeIn()

          var result = response.data.object.result
          var pos = []
          for (let i = 0; i < result.length; i++) {
            let positionObject = {
              lat: result[i].latitude,
              lng: result[i].longitude,
              dispatchDate: result[i].dispatchDate,
              driverName: result[i].driver ? result[i].driver.name : ''
            }
            pos.push(positionObject)
          }
          this.setState({
            delivery: response.data.object.result,
            partDelivery: response.data.object.result.slice(0, 10),
            buttonClicked: true,
            countAll: response.data.object.countAll,
            positions: pos,
            length: response.data.object.result.length,
            loading: false
          })
        } else {
          $('.showBaseTable,.print').fadeOut()
          this.setState({
            loading: false,
            positions: [],
            delivery: []
          })
        }
      })
  }

  createFilter = (exportStatus) => {
    let filter = {}
    var minDate = this.state.fromDate
    var maxDate = this.state.toDate

    let driverId = this.state.driverId == null || this.state.driverId == '' ? '' : this.state.driverId.personId
    let planTimeType = document.getElementById('planTimeType').value
    let locationIncompatible = document.getElementById('locationIncompatible').value
    let deliveredNotOnTime = document.getElementById('deliveredNotOnTime').value
    let timeStart = ''
    let timeEnd = ''
    let find = this.state.timesInterval.find((item) => +item.timeIntervalId === +planTimeType)
    filter.export = exportStatus
    filter.pageNumber = 1
    filter.sortBy = this.state.sortBy
    if (find) {
      timeStart = find.timeStart
      timeEnd = find.timeEnd
    }

    if (minDate) {
      filter.planDateMin = minDate
    }
    if (maxDate) {
      filter.planDateMax = maxDate
    }
    if (driverId) {
      filter.driverId = driverId
    }
    if (locationIncompatible) {
      filter.locationIncompatible = locationIncompatible
    }

    if (deliveredNotOnTime) {
      filter.deliveredNotOnTime = deliveredNotOnTime
    }
    if (timeStart) {
      filter.timeStart = timeStart
    }
    if (timeEnd) {
      filter.timeEnd = timeEnd
    }
    return filter
  }

  onChangePage(pageNumber) {
    // alert(pageNumber)
    this.setState({
      current: pageNumber,
      partDelivery: this.state.delivery.slice((pageNumber - 1) * 10, pageNumber * 10)
    })
  }

  componentDidMount() {
    http.get(`public/base/type/timeIntervals`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          timesInterval: response.data.object
        })
      }
    })

    http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_DRIVER}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          var drivers = response.data.object
          for (let i = 0; i < drivers.length; i++) {
            drivers[i]['value'] = drivers[i].personId
            drivers[i]['label'] = drivers[i].personId + ' - ' + drivers[i].name
          }

          this.setState({
            Drivers: response.data.object
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    sessionStorage.setItem('params', '')
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.sortBy !== this.state.sortBy) {
      this.getReport(true)
    }
  }

  getValueDriver = (driverId) => {
    this.setState({
      driverId
    })
  }

  filter() {
    // sessionStorage.setItem("pageNumber", "1");

    var minDate = this.state.fromDate
    var maxDate = this.state.toDate

    // let driverId =
    //   this.state.driverId == null || this.state.driverId == ""
    //     ? ""
    //     : this.state.driverId.personId;
    // let planTimeType = document.getElementById("planTimeType").value;
    // let locationIncompatible = document.getElementById("locationIncompatible")
    //   .value;
    // let deliveredNotOnTime = document.getElementById("deliveredNotOnTime")
    //   .value;
    // let timeStart = "";
    // let timeEnd = "";
    // let find = this.state.timesInterval.find(
    //   (item) => +item.timeIntervalId === +planTimeType
    // );
    // if (find) {
    //   timeStart = find.timeStart;
    //   timeEnd = find.timeEnd;
    // }
    if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else if (!maxDate || !minDate) {
      message.error('هر دو تاریخ وارد شود')
    } else {
      this.setState({
        toPrintDate: minDate == '' ? '-' : jMoment(this.state.fromDate).format('jYY/jMM/jDD'),
        fromPrintDate: maxDate == '' ? '-' : jMoment(this.state.toDate).format('jYY/jMM/jDD'),
        driverName: this.state.driverId == null || this.state.driverId == '' ? '' : this.state.driverId.name,
        groupingStatus: Number(this.state.grouping),
        showingInfoWindow: false
      })
      var a = moment(minDate)
      var b = moment(maxDate)
      if (b.diff(a, 'days') > 30) {
        message.error('اختلاف تاریخ باید حداکثر تا ۳۰ روز باشد')
      } else {
        this.getReport(true)
      }
    }
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  getPrintInfo = () => {
    this.setState({
      loading: true
    })

    let filter = this.createFilter(true)

    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_DELIVERY_LOCATION}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error === null) {
          // alert(JSON.stringify(response.data))
          this.setState({
            printInfo: response.data.object.result,
            loading: false
          })
          setTimeout(() => {
            window.print()
          }, 2000)
        } else {
          this.setState({
            loading: false
          })
          // message.error(response.data.description)
        }
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
  }

  exportExcel = () => {
    this.setState({
      loading: true
    })
    let filter = this.createFilter(true)
    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_DELIVERY_LOCATION}`, {
        params: filter
      })
      .then((response) => {
        this.setState({
          loading: false
        })
        if (response.data.error == null) {
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['shift'] = excelReport[i]['from'] + ' - ' + excelReport[i]['to']
            excelReport[i]['dispatchDate'] = jMoment(excelReport[i]['dispatchDate']).format('jYY/jM/jD HH:mm')
            if (excelReport[i]['deliveredBetween']) {
              excelReport[i]['deliveredBetween'] = 'در بازه'
            } else {
              excelReport[i]['deliveredBetween'] = 'خارج از بازه'
            }

            if (!excelReport[i]['locationIncompatible']) {
              excelReport[i]['locationIncompatible'] = 'تحویل در مکان مورد نظر'
            } else {
              excelReport[i]['locationIncompatible'] = 'عدم تحویل در مکان مورد نظر'
            }
          }
          this._export.save(this.state.excelReport)
        }
      })
  }

  onMarkerClick(props, marker, e) {
    console.log(props)
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true
    })
  }

  openMap = (latitude, longitude, recipientName, customerLatitude, customerLongitude, address) => {
    this.setState({
      latitude,
      longitude,
      recipientName,
      customerLatitude,
      customerLongitude,
      address,
      mapModal: true
    })
  }
  closeMap = () => {
    this.setState({
      latitude: '',
      address: '',
      longitude: '',
      recipientName: '',
      customerLatitude: '',
      customerLongitude: '',
      mapModal: false
    })
  }

  getMarkers() {
    let points = this.state.positions
    console.log(points)
    const array = []
    points.forEach((item) => {
      if (item.lat && item.lng) {
        array.push({
          location: [item.lat, item.lng],
          ...item
        })
      }
    })
    return array
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  render() {
    const unSelected = renderToStaticMarkup(<img src={require('../../image/requestPack.png')} />)
    const selected = renderToStaticMarkup(<img src={require('../../image/finishPack.png')} />)
    let {loading} = this.state
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let urlParams = sessionStorage.getItem('params')
    let pageNumber = sessionStorage.getItem('pageNumber')
    let reporterName = cookie.load('name')
    let printCol = [
      'ردیف',
      'راننده',
      'شیفت زمانی',
      'تاریخ تحویل',
      'تحویل ',
      'شناسه فاکتور',
      'شماره فاکتور',
      'خریدار',
      'تحویل گیرنده',
      'موبایل',
      'وضعیت تحویل'
    ]

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName={' گزارش تحویل بر مبنای موقعیت برای : ' + this.state.driverName + '.xls'}
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'driver'}
                field={'driver.name'}
                title={'راننده'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'shift'}
                field={'shift'}
                title={'شیفت زمانی'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'dispatchDate'}
                field={'dispatchDate'}
                title={'تاریخ تحویل'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'deliveredBetween'}
                field={'deliveredBetween'}
                title={'تحویل'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'invoiceId'}
                field={'invoice.invoiceId'}
                title={'شناسه فاکتور'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'invoiceNum'}
                field={'invoice.invoiceNum'}
                title={'شماره فاکتور'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'buyerName'}
                field={'invoice.buyerName'}
                title={'خریدار'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'recipinetName'}
                field={'invoice.recipientName'}
                title={'تحویل گیرنده'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'mobile'}
                field={'invoice.mobile'}
                title={'موبایل'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'locationIncompatible'}
                field={'locationIncompatible'}
                title={'وضعیت تحویل'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'address'}
                field={'invoice.address'}
                title={'موقعیت ثبت شده در فاکتور'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header={' گزارش تحویل بر مبنای موقعیت برای : ' + this.state.driverName}
              reporter={reporterName}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              headerColSpan={11}
              rightColSpan={6}
              centerColSpan={1}
              leftColSpan={4}
              centerSection={''}
              rightSection={
                'تاریخ از : ' +
                (this.state.toPrintDate === undefined ? '' : this.state.toPrintDate) +
                ' تا ' +
                (this.state.fromPrintDate === undefined ? '' : this.state.fromPrintDate)
              }
              columns={printCol}
            />

            <tbody>
              {this.state.printInfo.map((list, index) => (
                <tr key={'i' + index} style={index % 2 == 0 ? {backgroundColor: '#f1f1f1'} : {backgroundColor: '#fff'}}>
                  <td>{index + 1}</td>
                  <td>{list.driver.name}</td>
                  <td>
                    <TimeDisplay value={list} label=" تا " />
                  </td>
                  <td>{jMoment(list.dispatchDate).format('jYY/jM/jD HH:mm')}</td>
                  <td>{list.deliveredBetween ? 'در بازه' : 'خارج از بازه'}</td>
                  <td>{list.invoice.invoiceId}</td>
                  <td>{list.invoice.invoiceNum}</td>
                  <td>{list.invoice.buyerName}</td>
                  <td>{list.invoice.recipientName}</td>
                  <td>{list.invoice.mobile == null ? '-' : list.invoice.mobile.replace(/\+98/g, '0')}</td>
                  <td>{!list.locationIncompatible ? 'تحویل در مکان مورد نظر' : 'عدم تحویل در مکان مورد نظر'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>توزیع</li>
            <li>تحویل فاکتور ها</li>
            <li>گزارش موقعیت ها</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid enablePageSize={false} createLink="" />
                {/* <HeaderTable
                  addUrl=""
                  printUrl=""
                  url={
                    REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_DELIVERY_LOCATION
                  }
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printComponent={this.printTable}
                  execelUrl={
                    REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_DELIVERY_LOCATION +
                    "?export=true"
                  }
                  excelColumns={[]}
                  titleAdd=""
                  printLink=""
                /> */}
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ از"
                  toLabel="تاریخ تا"
                  defaulValue={true}
                  force
                  fromId="from"
                  toId="to"
                />

                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.Drivers}
                    getValueCombo={this.getValueDriver}
                    lableText="رساننده"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    isDisabled={false}
                  />
                </div>

                <div className="formComponent">
                  <label>شیفت زمانی :</label>
                  <select className="form-control" id="planTimeType">
                    <option value="">-------</option>
                    {this.state.timesInterval.map((shift, index) => (
                      <option value={shift.timeIntervalId}>{shift.timeStart + ' تا ' + shift.timeEnd}</option>
                    ))}
                  </select>
                </div>
                <div className="formComponent">
                  <label>وضعیت تحویل</label>
                  <select className="form-control" id="locationIncompatible">
                    <option value={''}>------</option>
                    <option value={false}>تحویل در مکان مورد نظر</option>
                    <option value={true}>عدم تحویل در مکان مورد نظر</option>
                  </select>
                </div>
                <div className="formComponent">
                  <label>تحویل خارج از بازه زمانی</label>
                  <select className="form-control" id="deliveredNotOnTime">
                    <option value={''}>------</option>
                    <option value={true}>بله</option>
                    <option value={false}>خیر</option>
                  </select>
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>
            <div className="addressMap">
              <Map center={[35.6892, 51.389]} zoom={10} style={{height: '500px', zIndex: 0}}>
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                {this.getMarkers().map((item, index) => (
                  <Marker position={item.location}>
                    <Popup>
                      <div className="text-center">{item.driverName}</div>
                      <div className="text-center">
                        {item.dispatchDate && jMoment(item.dispatchDate).format('jYYYY/jMM/jDD HH:mm')}
                      </div>
                    </Popup>
                  </Marker>
                ))}
                <Polyline positions={this.getMarkers()} />
              </Map>
            </div>
            <div className="showBaseTable print">
              <table className="baseTable">
                <Sort data={this.state.sortData} getSort={this.getSort} />
                <tbody>
                  {/* <tr className="firstRow">
                    <td>راننده</td>
                    <td>شیفت زمانی</td>
                    <td>تاریخ تحویل</td>
                    <td>تحویل </td>
                    <td>شناسه فاکتور</td>
                    <td>شماره فاکتور</td>
                    <td> خریدار</td>
                    <td> تحویل گیرنده</td>
                    <td>موبایل</td>
                    <td>وضعیت تحویل</td>
                    <td>موقعیت</td>
                  </tr> */}
                  {this.state.delivery.map((list, index) => (
                    <tr
                      key={index}
                      style={
                        list.supplyOrderQuantity !== list.cardexQuantity ||
                        list.deliveryQuantity !== list.detailQuantity
                          ? {backgroundColor: '#fdcccc'}
                          : {}
                      }
                    >
                      <td>{index + 1}</td>
                      <td>{list.driver.name}</td>
                      <td>
                        <TimeDisplay value={list} label=" تا " />
                      </td>
                      <td>{jMoment(list.dispatchDate).format('jYY/jM/jD HH:mm')}</td>
                      <td>{list.deliveredBetween ? 'بازه' : 'خارج از بازه'}</td>
                      <td>
                        <Link
                          to={{
                            pathname: '/baskets',
                            search: `?invoiceId=${list.invoice.invoiceId}`
                          }}
                          target={'_blank'}
                        >
                          {list.invoice.invoiceId}
                        </Link>
                      </td>
                      {/* <td>{list.invoice.invoiceNum}</td> */}
                      <td>{list.invoice.buyerName}</td>
                      {/* <td>{list.invoice.recipientName}</td> */}
                      {/* <td>
                        {list.invoice.mobile == null
                          ? "-"
                          : list.invoice.mobile.replace(/\+98/g, "0")}
                      </td> */}
                      <td>{list.invoice.address}</td>
                      <td>{!list.locationIncompatible ? 'تحویل در مکان مورد نظر' : 'عدم تحویل در مکان مورد نظر'}</td>
                      <td>
                        <button
                          onClick={() =>
                            this.openMap(
                              list.latitude,
                              list.longitude,
                              list.invoice.recipientName,
                              list.invoice.latitude,
                              list.invoice.longitude,
                              list.invoice.address
                            )
                          }
                        >
                          <img src={require('../../image/loc.svg')} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <div className="paginationWrapp">
                <Pagination
                  current={this.state.current}
                  onChange={this.onChangePage.bind(this)}
                  total={this.state.length}
                />
              </div> */}
            </div>
          </div>
        </div>
        <Modal isOpen={this.state.mapModal} toggle={this.closeMap} size="lg">
          <ModalHeader toggle={this.closeMap}>
            <p>موقعیت تحویل سفارش برای : {this.state.recipientName}</p>
            <p>
              موقعیت ثبت شده در فاکتور :{' '}
              {this.state.customerLatitude === null || this.state.customerLatitude === 0 ? (
                'موقعیتی ثبت نشده است'
              ) : (
                <img src={require('../../image/requestPack.png')} />
              )}
            </p>
            <p>آدرس ثبت شده در فاکتور : {this.state.address}</p>
            <p>
              موقعیت تحویل شده : <img src={require('../../image/finishPack.png')} />
            </p>
          </ModalHeader>
          <ModalBody>
            <div className="bg-white">
              <Map center={[35.6892, 51.389]} zoom={10} style={{height: '500px'}}>
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

                {this.state.latitude && this.state.longitude && (
                  <Marker
                    position={[this.state.latitude, this.state.longitude]}
                    title={this.state.recipientName}
                    icon={divIcon({
                      html: selected,
                      iconSize: [30, 30],
                      iconAnchor: [10, 38]
                    })}
                  />
                )}

                {this.state.customerLatitude && this.state.customerLongitude && (
                  <Marker
                    position={[this.state.customerLatitude, this.state.customerLongitude]}
                    title="موقعیت ثبت شده توسط رساننده"
                    icon={divIcon({
                      html: unSelected,
                      iconSize: [30, 30],
                      iconAnchor: [10, 38]
                    })}
                  />
                )}
              </Map>
              {/* <Map
                google={this.props.google}
                zoom={13}
                style={modalStyle}
                initialCenter={{
                  lat: this.state.latitude,
                  lng: this.state.longitude,
                }}
              >
                {!(
                  this.state.latitude === null || this.state.latitude === 0
                ) && (
                  <Marker
                    icon={require("../../image/finishPack.png")}
                    title={this.state.recipientName}
                    position={{
                      lat: this.state.latitude,
                      lng: this.state.longitude,
                    }}
                  />
                )}

                {!(
                  this.state.customerLatitude === null ||
                  this.state.customerLatitude === ""
                ) && (
                  <Marker
                    icon={require("../../image/reverseRequest.png")}
                    title={"موقعیت ثبت شده توسط رساننده"}
                    position={{
                      lat: this.state.customerLatitude,
                      lng: this.state.customerLongitude,
                    }}
                  />
                )}
              </Map> */}
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" onClick={this.closeMap}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default DeliveryPackByLocation
